/**
 * Utility to detect and handle 403 "2FA session not found" errors
 *
 * When backend endpoints (orders, address-verified, update-password) return 403,
 * it means the user hasn't completed 2FA verification for the current session.
 * This utility redirects the user to the verification page.
 */

/**
 * Check if an error is a 403 2FA required error from the backend
 */
export function is2FARequired(error: any): boolean {
  const status = error?.status || error?.statusCode || error?.data?.statusCode
  if (status === 403) {
    return true
  }
  // Also check for the specific error message from backend
  const message = error?.message || error?.data?.message || error?.data?.error?.message || ''
  if (typeof message === 'string' && message.toLowerCase().includes('2fa session not found')) {
    return true
  }
  return false
}

/**
 * Redirect the user to the verification page with the current URL as returnUrl
 */
export function redirectTo2FAVerification(): void {
  if (typeof window === 'undefined') return
  const currentUrl = window.location.pathname + window.location.search
  const verificationUrl = `/account/verification?returnUrl=${encodeURIComponent(currentUrl)}`
  console.log(`[2FA] Session not found - redirecting to verification: ${verificationUrl}`)
  window.location.href = verificationUrl
}
